import React, {useEffect, useState} from 'react';
import {Drawer, Table} from 'antd';
import Pallet from "../../http_request/Model/pallet/Pallet";
import {toast} from "react-toastify";
import DrawerColumn from "./DrawerColumn";
import {useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";

const RowInventory = ({id,selectedLocation, openModal = false, setOpenModal}) => {
    const navigate = useNavigate();

    const [columns] = DrawerColumn(selectedLocation,id);
    const [open, setOpen] = useState(openModal);
    const [data, setData] = useState({});
    const [loading, setLoading] = useState(false);
    const filter = useSelector((state) => state.TableRedux.filter);
    const getAgain = useSelector((state) => state.TableRedux.getAgain);

    useEffect(() => {
        setOpen(openModal)
    }, [openModal])

    const handleCancel = () => {
        setOpen(false);
        setOpenModal(false);
    };

    useEffect(() => {


        if (id) {
            Pallet.request({
                beforeSend: () => {
                    setLoading(true)
                },
                success: (result) => {
                    setData(result);
                },
                error: ({error}) => {
                    toast.error(error?.data?.message);
                },
                final: () => {
                    setLoading(false)
                },
            }).addParams({id, ...filter}, true).palletRow();

        }

    }, [id, getAgain,open,filter]);
    return <Drawer height='70%'
                   title={`موجودی ${data?.factoryName ?? "..."}`}
                   placement='bottom'
                   closable={false}
                   onClose={handleCancel}
                   open={open}
    >

        <Table
            columns={columns}
            onRow={(row) => {
                return {

                    onDoubleClick: () => {
                        navigate(`/PalletStatus?palletId=${row.palletId}`);
                    },

                };
            }}

            dataSource={data?.result} loading={loading}
            pagination={false}/>
    </Drawer>


}

export default RowInventory;